export class RTCManager {

	/**
	 * TODO
	 * - Hook into speech manager
	 * - Provide events for join/leave messages (should be synced with room_join/leave anyway)
	 * - More control (mute & hide webcam)
	 */

	ws = null;
	roomID = "";
	_connected = false;
	pc = null
	stream;

	isMuted = {
		video: false,
		audio: false
	}

	permissionGranted = {
		video: false,
		audio: true
	}

	constructor(roomID, videoEnabled = true, audioEnabled = true) {
		this.roomID = roomID;
		this.isMuted.video = !videoEnabled;
		this.isMuted.audio = !audioEnabled;
		this.setPermissions(videoEnabled, audioEnabled)
	}

	setPermissions(videoEnabled = true, audioEnabled = true) {
		this.permissionGranted.video = videoEnabled;
		this.permissionGranted.audio = audioEnabled;
	}

	setRoom(roomID) {
		this.roomID = roomID
	}

	joinRoom(roomID) {
		this.setRoom(roomID)
		return this.join()
	}

	/**
	 * Returns if the RTC manager is connected to a call
	 * @returns {boolean}
	 */
	isConnected() {
		return this._connected
	}

	setConnected(status) {
		this._connected = status
		this._statusEvent()
	}

	/**
	 * Attempt to join a room
	 * @returns {Promise<MediaStream>}
	 */
	join() {
		return this.requestMediaDevices();
	}

	/**
	 *
	 * @returns {Promise<MediaStream>}
	 */
	requestMediaDevices() {
		console.log("RTCManager (permissionGranted):", this.permissionGranted);

		this.pc = new RTCPeerConnection();

		return window.navigator.mediaDevices.getUserMedia(this.permissionGranted).then((s) => {
			this.onStreamReceived(s) //Configure stream

		}).catch((e) => {
			console.error("No media devices available", e)
		});
	}

	connect() {
		if (this.ws !== null) {
			console.log("RTCManager: Already connected");
			return; //Already connected
		}

		console.log("Connecting to media WS:", this.roomID);

		// this.ws = new WebSocket("ws://localhost:9093/webrtc/ws")
		this.ws = new WebSocket(`wss://app.alphabatem.com/webrtc/${this.roomID}/ws`)
		this.ws.onopen = (e) => this.onOpen(e)
		this.ws.onerror = (e) => this.onError(e)
		this.ws.onclose = (e) => this.onClose(e)
		this.ws.onmessage = (e) => this.onMessage(e)
	}

	onOpen(e) {
		console.log("RTC WS connected")
		this.setConnected(true)
	}

	onMessage(evt) {
		console.log("onMessage", evt)

		let msg = JSON.parse(evt.data)
		if (!msg) {
			return console.log('failed to parse msg')
		}

		switch (msg.event) {
			case 'offer':
				return this.onEventOffer(msg)
			case 'candidate':
				return this.onEventCandidate(msg)
		}
	}

	onEventOffer(msg) {
		let offer = JSON.parse(msg.data)
		if (!offer) {
			return console.log('failed to parse answer')
		}
		if (!this.pc)
			return

		this.pc.setRemoteDescription(offer)
		this.pc.createAnswer().then(answer => {
			this.pc.setLocalDescription(answer)
			this.ws.send(JSON.stringify({event: 'answer', data: JSON.stringify(answer)}))
		})
	}

	onEventCandidate(msg) {
		let candidate = JSON.parse(msg.data)
		if (!candidate) {
			return console.log('failed to parse candidate')
		}
		if (!this.pc)
			return

		return this.pc.addIceCandidate(candidate)
	}

	onClose(e) {
		this.stopStreams();
		this.setConnected(false)
		this.ws = null;
		console.log("onClose", e)
	}

	onError(e) {
		this.setConnected(false)
		this.ws = null;
		console.log("onError", e)
		console.log("ERROR: " + e.data)
	}

	onIceCandidate(e) {
		console.log("onIceCandidate", e)
		if (!e.candidate) {
			return
		}

		this.ws.send(JSON.stringify({event: 'candidate', data: JSON.stringify(e.candidate)}))
	}

	onPeerTrack(e) {
		//STUB - Handle what you want to do with stream
	}

	onStreamReceived(stream) {
		console.log("Received stream", stream)
		this.stream = stream

		this.connect(); //Connect to media WS
		this.pc.onicecandidate = (e) => this.onIceCandidate(e)
		this.pc.ontrack = (e) => this.onPeerTrack(e)

		this.stream.getTracks().forEach(track => {
			console.log("Adding local track", track)
			this.pc.addTrack(track, this.stream)
		})
	}


	muteMic() {
		if (!this.permissionGranted.audio) {
			this.isMuted.audio = false
			this.permissionGranted.audio = true; //Explicit click from the user indicates intention

			//Re-request these new permissions
			return this.requestMediaDevices()
		}

		this.isMuted.audio = !this.isMuted.audio
		console.log("Muting microphone:", this.isMuted.audio)
		this.stream.getAudioTracks().forEach(track => track.enabled = !track.enabled);
	}

	muteCam() {
		if (!this.permissionGranted.video) {
			this.isMuted.video = false
			this.permissionGranted.video = true; //Explicit click from the user indicates intention

			//Re-request these new permissions
			return this.requestMediaDevices()
		}

		this.isMuted.video = !this.isMuted.video
		console.log("Muting camera:", this.isMuted.video)
		this.stream.getVideoTracks().forEach(track => track.enabled = !track.enabled);
	}

	/**
	 * Data
	 */

	sendFile(file) {
		console.log(`File is ${[file.name, file.size, file.type, file.lastModified].join(' ')}`);

		// Handle 0 size files.
		if (file.size === 0) {
			// statusMessage.textContent = 'File is empty, please select a non-empty file';
			closeDataChannels();
			return;
		}

		const chunkSize = 16384;
		let fileReader = new FileReader();
		let offset = 0;
		fileReader.addEventListener('error', error => console.error('Error reading file:', error));
		fileReader.addEventListener('abort', event => console.log('File reading aborted:', event));
		fileReader.addEventListener('load', e => {
			console.log('FileRead.onload ', e);
			sendChannel.send(e.target.result);
			offset += e.target.result.byteLength;
			if (offset < file.size) {
				readSlice(offset);
			}
		});
		const readSlice = o => {
			console.log('readSlice ', o);
			const slice = file.slice(offset, o + chunkSize);
			fileReader.readAsArrayBuffer(slice);
		};
		readSlice(0);
	}

	stopStreams() {
		if (!this.stream) return
		this.stream.getTracks().forEach(function (track) {
			track.stop();
		});
	}

	reset() {
		this.ws = null;
		this.roomID = "";
		this.pc = null

		this.setConnected(false)
		this.stopStreams();
		this.stream = null;

		this.isMuted = {
			video: false,
			audio: false
		}
	}

	_statusEvent() {
		window.dispatchEvent(new CustomEvent("meeting_status", {
			detail: {connected: this._connected, room_id: this.roomID}
		}))
	}
}